import { LogService } from '@macs-frontend/core/services/log.service';
import { WindowService } from '@macs-frontend/core/services/window.service';

export const CORE_PROVIDERS: any[] = [LogService, WindowService];

export * from '@macs-frontend/core/services/log.service';
export * from '@macs-frontend/core/services/tokens';
export * from '@macs-frontend/core/services/window.service';
